import React, { Fragment, useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import {TransactionPage} from "../Transaction/Transaction";
import { useHistory, useLocation } from "react-router";

// import "./CustomPayment.css";
// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// loadStripe is initialized with a fake API key.
// Sign in to see examples pre-filled with your key.
export const CustomPaymentPage = () => {
    const { state: stateParams } = useLocation();
    const history = useHistory();
    const promise = loadStripe(stateParams.publishablekey);

  return (
    <div className="App">
      <Elements stripe={promise}>
        <TransactionPage data={stateParams}/>
      </Elements>
    </div>
  );
}